import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AddProjectComponent } from "./add-project/add-project.component";
import { AddRotationComponent } from "./add-rotation/add-rotation.component";
import { AnnouncementComponent } from "./announcement/announcement.component";
import { AvailabilityRequestComponent } from "./availability-request/availability-request.component";
import { BlockRequestsListComponent } from "./block-requests-list/block-requests-list.component";
import { CampaignsComponent } from "./campaigns/campaigns.component";
import { CliComponent } from "./cli/cli.component";
import { ContractGenerateComponent } from "./contract-generate/contract-generate.component";
import { DailyReportComponent } from "./daily-report/daily-report.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { DuplicatedLeadsComponent } from "./duplicated-leads/duplicated-leads.component";
import { EoiTableComponent } from "./eois/eoi-table/eoi-table.component";
import { EoiComponent } from "./eois/eoi/eoi.component";
import { FinanceAccountsComponent } from "./finance-accounts/finance-accounts.component";
import { FinanceAddAccountComponent } from "./finance-add-account/finance-add-account.component";
import { FinanceAddTransactionComponent } from "./finance-add-transaction/finance-add-transaction.component";
import { FinanceBalanceSheetComponent } from "./finance-balance-sheet/finance-balance-sheet.component";
import { FinanceTransactionComponent } from "./finance-transaction/finance-transaction.component";
import { FinancialReportComponent } from "./financial-report/financial-report.component";
import { AddLeadGuard } from "./guards/addLead.guard";
import { AddProjectGuard } from "./guards/addProject.guard";
import { AuthGuard } from "./guards/authguard.guard";
import { LeadsGuard } from "./guards/leads.guard";
import { LoginGuard } from "./guards/login.guard";
import { PaymentGeneratorGuard } from "./guards/paymentGenerator.guard";
import { CanEnterProjectsTab } from "./guards/projects.guard";
import { ReservationsGuard } from "./guards/reservations.guard";
import { SettingTabGuard } from "./guards/settingsTab.guard";
import { WalletGuard } from "./guards/wallet.guard";
import { ImportUnitsComponent } from "./import-units/import-units.component";
import { AddLeadComponent } from "./lead/addLead/addlead.component";
import { LeadsComponent } from "./lead/dashboard/lead.component";
import { LoginComponent } from "./login/login.component";
import { LogsComponent } from "./logs/logs.component";
import { MainComponent } from "./main/main.component";
import { MarketingReportsComponent } from "./marketing-reports/marketing-reports.component";
import { MarketingComponent } from "./marketing/marketing.component";
import { MasterPlanComponent } from "./master-plan/master-plan.component";
import { NotificationsComponent } from "./notifications/notifications.component";
import { PaymentCollectionsComponent } from "./payment-collections/payment-collections.component";
import { PaymentGeneratorComponent } from "./payment-generator/payment-generator.component";
import { PriceControlComponent } from "./price-control/price-control.component";
import { PriceControllerRequestsComponent } from "./price-controller-requests/price-controller-requests.component";
import { ProfileComponent } from "./profile/profile.component";
import { ProjectsComponent } from "./projects/projects.component";
import { ReminderComponent } from "./reminder/reminder.component";
import { ReportsComponent } from "./reports/reports.component";
import { WalletComponent } from "./reports/wallet/wallet.component";
import { ReservationViewComponent } from "./reservation-view/reservation-view.component";
import { AddreservationComponent } from "./reservation/addreservation/addreservation.component";
import { ReservationComponent } from "./reservation/reservation.component";
import { RotationLogsComponent } from "./rotation-logs/rotation-logs.component";
import { RotationComponent } from "./rotation/rotation.component";
import { TrashLeadsComponent } from "./trash-leads/trash-leads.component";
import { UnitViewComponent } from "./unit-view/unit-view.component";
import { UnitsComponent } from "./units/units.component";
import { UploadLayoutComponent } from "./upload-layout/upload-layout.component";

import { AddTicketComponent } from "./add-ticket/add-ticket.component";
import { BankChequeListingComponent } from "./bank-cheque-listing/bank-cheque-listing.component";
import { ClientStatementsComponent } from "./client-statements/client-statements.component";
import { ColdCallsSheetsComponent } from "./cold-calls-sheets/cold-calls-sheets.component";
import { CustomersBirthdayComponent } from "./customers-birthday/customers-birthday.component";
import { AddEoiComponent } from "./eois/add-eoi/add-eoi.component";
import { EoiViewComponent } from "./eois/eoi-view/eoi-view.component";
import { FinesListComponent } from "./fines-list/fines-list.component";
import { AddHoldComponent } from "./hold-module/add-hold/add-hold.component";
import { HoldDetailsComponent } from "./hold-module/hold-details/hold-details.component";
import { HoldListComponent } from "./hold-module/hold-list/hold-list.component";
import { ListingLeadsByActivitesComponent } from "./listing-leads-by-activites/listing-leads-by-activites.component";
import { MailBuilderComponent } from "./mail-builder/mail-builder.component";
import { PaymentCollectionViewComponent } from "./payment-collection-view/payment-collection-view.component";
import { PrintChequeComponent } from "./print-cheque/print-cheque.component";
import { RotationsListComponent } from "./rotations-list/rotations-list.component";
import { TicketViewComponent } from "./ticket-view/ticket-view.component";
import { TicketsComponent } from "./tickets/tickets.component";
import { ViewClientStatementsComponent } from "./view-client-statements/view-client-statements.component";
import { BrokersListComponent } from "./brokers-list/brokers-list.component";
import { ProjectBulkCalculatorComponent } from "./project-bulk-calculator/project-bulk-calculator.component";
import { BrokerWalletComponent } from "./reports/broker-wallet/broker-wallet.component";
import { BrokerWalletGuard } from "./guards/broker-wallet.guard";
import { UploadProjectOfferImagesComponent } from "./upload-project-offer-images/upload-project-offer-images.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: "pages",
    pathMatch: "full",
  },
  {
    path: "login",
    component: LoginComponent,
    canActivate: [LoginGuard],
  },
  {
    path: "pages",
    component: MainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        redirectTo: "dashboard",
        pathMatch: "full",
      },
      {
        path: "dashboard",
        component: DashboardComponent,
      },
      {
        path: "leads",
        component: LeadsComponent,
        canActivate: [LeadsGuard],
      },
      {
        path: "leads/:id",
        component: LeadsComponent,
        canActivate: [LeadsGuard],
      },
      {
        path: "clients-statements",
        component: ClientStatementsComponent,
      },
      {
        path: "clients-statements/:id",
        component: ViewClientStatementsComponent,
      },
      {
        path: "leads-listing-activites",
        component: ListingLeadsByActivitesComponent,
      },
      {
        path: "duplicated-leads",
        component: DuplicatedLeadsComponent,
        canActivate: [LeadsGuard],
      },
      {
        path: "trash-leads",
        component: TrashLeadsComponent,
      },
      {
        path: "eoi/:id",
        component: EoiComponent,
      },
      {
        path: "eoi-table",
        component: EoiTableComponent,
        // canActivate: [EoisGuard],
      },
      {
        path: "eoi-view/:id",
        component: EoiViewComponent,
      },
      {
        path: "add-hold/:id",
        component: AddHoldComponent,
      },
      {
        path: "hold-list",
        component: HoldListComponent,
        // canActivate: [EoisGuard],
      },
      {
        path: "hold-details/:id",
        component: HoldDetailsComponent,
      },
      {
        path: "addLead/:id",
        component: AddLeadComponent,
        canActivate: [AddLeadGuard],
      },
      {
        path: "projects",
        component: ProjectsComponent,
        canActivate: [CanEnterProjectsTab],
      },
      {
        path: "projects/import-units",
        component: ImportUnitsComponent,
      },
      {
        path: "projects/upload-offer-images",
        component: UploadProjectOfferImagesComponent,
      },
      {
        path: "projects/units/:id",
        component: UnitsComponent,
        canActivate: [CanEnterProjectsTab],
      },
      {
        path: "projects/view-all-units",
        component: UnitsComponent,
        canActivate: [CanEnterProjectsTab],
      },
      // {
      //   path: 'projects/view-all-units',
      //   component: AllUnitViewComponent,
      //   canActivate: [CanEnterProjectsTab]
      // },
      {
        path: "projects/block-requests-list",
        component: BlockRequestsListComponent,
      },
      {
        path: "settings",
        loadChildren: "./main-settings/main-settings.module#MainSettingsModule",
        ///using this syntax due to error TS1323. check this for refrence
        //https://stackoverflow.com/questions/56375703/angular-8-lazy-loading-modules-error-ts1323-dynamic-import-is-only-supporte
      },
      {
        path: "reservations",
        component: ReservationComponent,
        canActivate: [ReservationsGuard],
      },
      {
        path: "reservations/add/:id",
        component: AddreservationComponent,
      },
      {
        path: "projects/add/:id",
        component: AddProjectComponent,
        canActivate: [CanEnterProjectsTab, AddProjectGuard],
      },
      {
        path: "payment-generator",
        component: PaymentGeneratorComponent,
        canActivate: [PaymentGeneratorGuard],
      },
      {
        path: "project-bulk-calculator",
        component: ProjectBulkCalculatorComponent,
      },
      {
        path: "payment-collections",
        component: PaymentCollectionsComponent,
      },
      {
        path: "payment-collections/:id",
        component: PaymentCollectionViewComponent,
      },
      {
        path: "fines-list",
        component: FinesListComponent,
      },
      {
        path: "projects/conrtact-generate",
        component: ContractGenerateComponent,
      },
      {
        path: "projects/view-unit",
        component: UnitViewComponent,
      },
      {
        path: "upload-layout",
        component: UploadLayoutComponent,
        canActivate: [SettingTabGuard],
      },
      {
        path: "project/view-reservation",
        component: ReservationViewComponent,
      },
      {
        path: "project/view-reservation/:id",
        component: ReservationViewComponent,
      },
      {
        path: "profile",
        component: ProfileComponent,
      },
      {
        path: "finance/accounts",
        component: FinanceAccountsComponent,
      },
      {
        path: "finance/accounts/add/:id",
        component: FinanceAddAccountComponent,
      },
      {
        path: "finance/balance-sheet",
        component: FinanceBalanceSheetComponent,
      },
      {
        path: "finance/transaction",
        component: FinanceTransactionComponent,
      },
      {
        path: "finance/transaction/add",
        component: FinanceAddTransactionComponent,
      },
      {
        path: "notifications",
        component: NotificationsComponent,
      },
      {
        path: "marketing",
        component: MarketingComponent,
      },
      {
        path: "reports",
        component: ReportsComponent,
      },
      {
        path: "cils",
        component: CliComponent,
      },
      {
        path: "availability-request",
        component: AvailabilityRequestComponent,
      },
      {
        path: "price-control",
        component: PriceControlComponent,
      },
      {
        path: "price-control/requests",
        component: PriceControllerRequestsComponent,
      },
      {
        path: "master-plan",
        component: MasterPlanComponent,
      },
      {
        path: "wallet",
        component: WalletComponent,
        canActivate: [WalletGuard],
      },
      {
        path: "broker-wallet",
        component: BrokerWalletComponent,
        canActivate: [BrokerWalletGuard],
      },
      {
        path: "brokers",
        children: [
          {
            path: "list",
            component: BrokersListComponent,
          },
          {
            path: "",
            redirectTo: "list",
            pathMatch: "full",
          },
        ],
      },
      {
        path: "announcement",
        component: AnnouncementComponent,
      },
      {
        path: "rotation",
        component: RotationComponent,
      },
      {
        path: "campaigns",
        component: CampaignsComponent,
      },
      {
        path: "rotation-logs",
        component: RotationLogsComponent,
      },
      {
        path: "logs",
        component: LogsComponent,
      },
      {
        path: "marketing-reports",
        component: MarketingReportsComponent,
      },
      {
        path: "reminder",
        component: ReminderComponent,
      },
      {
        path: "daily-report",
        component: DailyReportComponent,
      },
      {
        path: "financial-report",
        component: FinancialReportComponent,
      },
      {
        path: "rotation/add",
        component: AddRotationComponent,
      },
      {
        path: "rotations",
        component: RotationsListComponent,
      },
      {
        path: "bank-cheque-listing",
        component: BankChequeListingComponent,
      },
      {
        path: "print-cheque",
        component: PrintChequeComponent,
      },
      {
        path: "cold-calls",
        children: [
          {
            path: "sheets",
            component: ColdCallsSheetsComponent,
          },
        ],
      },
      {
        path: "mail-builder",
        component: MailBuilderComponent,
      },
      {
        path: "add-eoi",
        component: AddEoiComponent,
      },
      {
        path: "add-ticket",
        // loadChildren: './main-settings/main-settings.module#MainSettingsModule'
        component: AddTicketComponent,
      },
      {
        path: "edit-ticket/:id",
        component: AddTicketComponent,
      },
      {
        path: "tickets",
        component: TicketsComponent,
      },
      {
        path: "view-ticket/:id",
        // loadChildren: './tickets/tickets.module#TicketsModule',
        component: TicketViewComponent,
      },
      {
        path: "legal-affairs",
        loadChildren: "./legal-affairs/legal-affairs.module#LegalAffairsModule",
      },
      {
        path: "customers-birthday",
        component: CustomersBirthdayComponent,
      },
    ],
  },
  {
    path: "**",
    redirectTo: "pages",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts